'use client';

import Header from "@/components/layout/Header/Header";
import Footer from "@/components/layout/Footer/Footer";
import UserWelcomeBar from "@/components/layout/UserWelcomeBar/UserWelcomeBar";
import SupportForm, {
  SupportFormValues,
} from "@/components/layout/SupportForm/SupportForm";
import styles from "@/styles/layout/Soporte.module.css";
import { message } from "antd";
import { useState } from "react";
import { insertSupportForm } from "@/services/database/insertData";
import { BRANDING } from "@/config/brand";
import proyectosData from "@/data/proyectos.json"

export default function Soporte() {
  const [loading, setLoading] = useState(false);
  const [ticketEnviado, setTicketEnviado] = useState(false);

  const handleFormSubmit = async (values: SupportFormValues) => {
    setLoading(true);

    try {
      let nombreProyecto = values.proyecto;
      if (values.proyecto === "otro") {
        nombreProyecto = values.proyectoOtro as string;
      } else {
        const proyectoEncontrado = proyectosData.find(
          (p) => p.id === values.proyecto
        );
        nombreProyecto = proyectoEncontrado ? proyectoEncontrado.nombre : values.proyecto;
      }

      const payload = {
        issue_type: "software",
        cedula: values.cedula,
        nombre_completo: values.nombre_completo,
        correo_electronico: values.correo_electronico,
        numero_contacto: values.numero_contacto,
        departamento: values.departamento,
        municipio: values.municipio,
        institucion: values.institucion,
        sede: values.sede,
        cargo: values.cargo,
        proyecto: nombreProyecto,
        desarrollo: values.desarrollo, // <-- Se agrega el campo desarrollo
        asunto: values.asunto,
        descripcion: values.descripcion,
        acepta_tratamiento: values.acepta_tratamiento as boolean,
        archivos: values.archivos || [],
      };
      await insertSupportForm(payload);
      setTicketEnviado(true);
      message.success("Formulario enviado exitosamente.");
    } catch (error) {
      console.error("Error al insertar en la base de datos:", error);
      message.error(
        "Ocurrió un error al enviar el formulario. Inténtelo de nuevo."
      );
    } finally {
      setLoading(false);
    }
  };

  const brand = "talentum";
  const logo = BRANDING[brand].header_logo;

  return (
    <>
      <Header logo={logo} />
      <UserWelcomeBar />
      <main className="content">
        <div className={styles.container}>
          <h1 className={styles.title}>Soporte Técnico</h1>
          <p className={styles.description}>
            Bienvenido al centro de soporte interno de Corporación Talentum. Aquí puedes contactar
            al equipo técnico para resolver tus requerimientos o incidentes.
          </p>
          {!ticketEnviado ? (
            <>
              <SupportForm
                onSubmit={handleFormSubmit}
                loading={loading}
                tipoProblema={"software"}
              />
            </>
          ) : (
            <div className={styles.confirmationMessage}>
              <h2 style={{ color: "green" }}>
                Mensaje enviado al soporte técnico.
              </h2>
            </div>
          )}
        </div>
      </main>

      <Footer brand={brand} />
    </>
  );
}
